import { render } from "./ModalDownload.vue?vue&type=template&id=fe4f51d2&scoped=true"
import script from "./ModalDownload.vue?vue&type=script&lang=js"
export * from "./ModalDownload.vue?vue&type=script&lang=js"

import "./ModalDownload.vue?vue&type=style&index=0&id=fe4f51d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4f51d2"]])

export default __exports__